import { ROUTE } from "../../../../routes";
import { AssetRepositoryType } from "../../../../configs/config";
import AsyncStorage from "@react-native-async-storage/async-storage";
import SharedPropsService from "../../../../SharedPropsService";
export const refreshPortfolioAction = async (action, _datastore, { navigate, instrumentTrack }) => {
    await instrumentTrack("REFRESH_LIMIT_CLICKED_LIMIT_SCREEN");
    await navigate(ROUTE.MF_FETCH_PORTFOLIO);
};
export const goBackAction = async (action, _datastore, { navigate, goBack }) => {
    const applicationId = await AsyncStorage.getItem("application_id");
    const isFromEnhanceLimit = applicationId !== null;
    const shouldShowHome = await SharedPropsService.showHome();
    const isFromElevate = await SharedPropsService.getElevateFlow();
    if (isFromElevate && shouldShowHome) {
        await navigate(ROUTE.DASHBOARD);
    }
    else if (isFromEnhanceLimit) {
        await navigate(ROUTE.MANAGE_LIMIT_LANDING);
    }
    else {
        if (shouldShowHome) {
            await navigate(ROUTE.BORROWER_LANDING_SCREEN);
        }
    }
};
export const setCreditLimitAction = async (action, _datastore, { navigate }) => {
    const minimumEligibleLimitAmount = action?.payload?.minimumEligibleLimit;
    await navigate(ROUTE.SET_CREDIT_LIMIT, {
        isFromMFCentral: true,
        minimumEligibleLimitAmount: minimumEligibleLimitAmount?.amount
    });
};
export const viewYourMutualFundsAction = async (action, _datastore, { navigate, instrumentTrack }) => {
    await instrumentTrack("FETCHED_MUTUAL_FUNDS_CLICKED");
    await navigate(ROUTE.PORTFOLIO_FROM_RTA, {
        isFromMFCentral: true,
        assetRepository: AssetRepositoryType.MFCENTRAL
    });
};
